import { createRouter, RouteRecordRaw, createWebHistory } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layouts/main-layout/MainLayout.vue"),
    meta: {
      middleware: "auth",
    },
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
        meta: {
          pageTitle: "首页",
          breadcrumbs: ["首页"],
        },
      },
      {
        path: "/user/edit",
        name: "user.edit",
        component: () => import("@/views/user/Edit.vue"),
        meta: {
          pageTitle: "编辑",
          breadcrumbs: ["会员管理", "编辑"],
        },
      },
      {
        path: "/user",
        name: "user",
        component: () => import("@/views/user/Nav.vue"),
        children: [
          {
            path: "overview",
            name: "user.overview",
            component: () => import("@/views/user/Overview.vue"),
            meta: {
              pageTitle: "概况",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "settings",
            name: "user.settings",
            component: () => import("@/views/user/Settings.vue"),
            meta: {
              pageTitle: "基本信息",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "company",
            name: "user.company",
            component: () => import("@/views/content/company/Index.vue"),
            meta: {
              pageTitle: "公司",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "brand",
            name: "user.brand",
            component: () => import("@/views/content/brand/Index.vue"),
            meta: {
              pageTitle: "品牌",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "product",
            name: "user.product",
            component: () => import("@/views/content/product/Index.vue"),
            meta: {
              pageTitle: "产品",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "trade",
            name: "user.trade",
            component: () => import("@/views/content/trade/Index.vue"),
            meta: {
              pageTitle: "供需",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "article",
            name: "user.article",
            component: () => import("@/views/content/article/Index.vue"),
            meta: {
              pageTitle: "资讯",
              breadcrumbs: ["会员"],
            },
          },
          {
            path: "subject",
            name: "user.subject",
            component: () => import("@/views/content/subject/Index.vue"),
            meta: {
              pageTitle: "专题",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "activity",
            name: "user.activity",
            component: () => import("@/views/content/activity/Index.vue"),
            meta: {
              pageTitle: "活动",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "person",
            name: "user.person",
            component: () => import("@/views/content/person/Index.vue"),
            meta: {
              pageTitle: "人物",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "supplier",
            name: "user.supplier",
            component: () => import("@/views/content/supplier/Index.vue"),
            meta: {
              pageTitle: "供应链",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "manager",
            name: "user.manager",
            component: () => import("@/views/content/manager/Index.vue"),
            meta: {
              pageTitle: "管理层",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "staff",
            name: "user.staff",
            component: () => import("@/views/content/staff/Index.vue"),
            meta: {
              pageTitle: "员工",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "follow",
            name: "user.interact.follow",
            component: () => import("@/views/interact/follow/Index.vue"),
            meta: {
              pageTitle: "关注",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "likes",
            name: "user.interact.likes",
            component: () => import("@/views/interact/likes/Index.vue"),
            meta: {
              pageTitle: "点赞",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "favorites",
            name: "user.interact.favorites",
            component: () => import("@/views/interact/favorites/Index.vue"),
            meta: {
              pageTitle: "收藏",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "comment",
            name: "user.interact.comment",
            component: () => import("@/views/interact/comment/Index.vue"),
            meta: {
              pageTitle: "评论",
              breadcrumbs: ["会员管理"],
            },
          },
          {
            path: "message",
            name: "user.interact.message",
            component: () => import("@/views/interact/message/Index.vue"),
            meta: {
              pageTitle: "留言",
              breadcrumbs: ["会员管理"],
            },
          },
        ],
      },

      {
        path: "/content",
        name: "content",
        //component: () => import("@/views/user/Nav.vue"),
        children: [
          {
            path: "/content/company",
            name: "content.company",
            component: () => import("@/views/content/company/Edit.vue"),
            meta: {
              pageTitle: "公司",
              breadcrumbs: ["内容管理", "公司"],
            },
          },
          {
            path: "/content/brand",
            name: "content.brand",
            component: () => import("@/views/content/brand/Index.vue"),
            meta: {
              pageTitle: "品牌",
              breadcrumbs: ["内容管理", "品牌"],
            },
          },
          {
            path: "/content/product",
            name: "content.product",
            component: () => import("@/views/content/product/Index.vue"),
            meta: {
              pageTitle: "产品",
              breadcrumbs: ["内容管理", "产品"],
            },
          },
          {
            path: "/content/trade",
            name: "content.trade",
            component: () => import("@/views/content/trade/Index.vue"),
            meta: {
              pageTitle: "供需",
              breadcrumbs: ["内容管理", "供需"],
            },
          },
          {
            path: "/content/article",
            name: "content.article",
            component: () => import("@/views/content/article/Index.vue"),
            meta: {
              pageTitle: "资讯",
              breadcrumbs: ["内容管理", "资讯"],
            },
          },
          {
            path: "/content/subject",
            name: "content.subject",
            component: () => import("@/views/content/subject/Index.vue"),
            meta: {
              pageTitle: "专题",
              breadcrumbs: ["内容管理", "专题"],
            },
          },
          {
            path: "/content/activity",
            name: "content.activity",
            component: () => import("@/views/content/activity/Index.vue"),
            meta: {
              pageTitle: "活动",
              breadcrumbs: ["内容管理", "活动"],
            },
          },
          {
            path: "/content/person",
            name: "content.person",
            component: () => import("@/views/content/person/Index.vue"),
            meta: {
              pageTitle: "人物",
              breadcrumbs: ["内容管理", "人物"],
            },
          },
        ],
      },

      {
        path: "/interact",
        name: "interact",
        //component: () => import("@/views/user/Nav.vue"),
        children: [
          {
            path: "/interact/follow",
            name: "interact.follow",
            component: () => import("@/views/interact/follow/Index.vue"),
            meta: {
              pageTitle: "关注",
              breadcrumbs: ["互动管理", "关注"],
            },
          },
          {
            path: "/interact/fans",
            name: "interact.fans",
            component: () => import("@/views/interact/follow/Fans.vue"),
            meta: {
              pageTitle: "粉丝",
              breadcrumbs: ["互动管理", "粉丝"],
            },
          },
          {
            path: "/interact/likes",
            name: "interact.likes",
            component: () => import("@/views/interact/likes/Index.vue"),
            meta: {
              pageTitle: "获赞",
              breadcrumbs: ["互动管理", "获赞"],
            },
          },
          {
            path: "/interact/favorites",
            name: "interact.favorites",
            component: () => import("@/views/interact/favorites/Index.vue"),
            meta: {
              pageTitle: "收藏",
              breadcrumbs: ["互动管理", "收藏"],
            },
          },
          {
            path: "/interact/comment",
            name: "interact.comment",
            component: () => import("@/views/interact/comment/Index.vue"),
            meta: {
              pageTitle: "评论",
              breadcrumbs: ["互动管理", "评论"],
            },
          },
          {
            path: "/interact/message",
            name: "interact.message",
            component: () => import("@/views/interact/message/Index.vue"),
            meta: {
              pageTitle: "留言",
              breadcrumbs: ["互动管理", "留言"],
            },
          },
        ],
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () => import("@/views/authentication/SignIn.vue"),
        meta: {
          pageTitle: "登录",
        },
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () => import("@/views/authentication/SignUp.vue"),
        meta: {
          pageTitle: "注册",
        },
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () => import("@/views/authentication/PasswordReset.vue"),
        meta: {
          pageTitle: "Password reset",
        },
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/SystemLayout.vue"),
    children: [
      {
        path: "/404",
        name: "404",
        component: () => import("@/views/error/Error404.vue"),
        meta: {
          pageTitle: "Error 404",
        },
      },
      {
        path: "/500",
        name: "500",
        component: () => import("@/views/error/Error500.vue"),
        meta: {
          pageTitle: "Error 500",
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), // createWebHashHistory() | createWebHistory()
  routes,
});

router.beforeEach((to, from, next) => {
  // current page view title
  document.title = `${to.meta.pageTitle} - ${process.env.VUE_APP_NAME}`;

  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  // verify auth token before each page change
  store.dispatch(Actions.VERIFY_AUTH, { api_token: JwtService.getToken() });

  // before page access check if page requires authentication
  if (to.meta.middleware == "auth") {
    if (store.getters.isUserAuthenticated) {
      next();
    } else {
      next({ name: "sign-in" });
    }
  } else {
    next();
  }

  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
});

export default router;
